import { render, staticRenderFns } from "./ParamsForm.vue?vue&type=template&id=92898c6a"
import script from "./ParamsForm.vue?vue&type=script&lang=js"
export * from "./ParamsForm.vue?vue&type=script&lang=js"
import style0 from "./ParamsForm.vue?vue&type=style&index=0&id=92898c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports